import React from 'react';
import itemList from '../data/itemMap.json';

const itemMap = Object.fromEntries(
    itemList.map(item => [String(item.id), item.name])
);

export default function ItemIcon({ id, size = 32 }) {
    const name = itemMap[id] || id;
    return (
        <img
            src={`/items/${id}.png`}
            alt={`Item ${id}`}
            title={name}
            width={size}
            height={size}
            style={{ verticalAlign: 'middle', margin: '0 4px' }}
            className="item-icon"
        />
    );
}